import type { ProjectStatus } from "@/modules/management/project/domain/types";
import { cn } from "@devhop/ui";
import { projectStatusProgressFillClass } from "../lib/project-status-progress-styles";

type ProjectProgressBarProps = {
  status: ProjectStatus;
  value: number;
  className?: string;
  "aria-label"?: string;
};

export function ProjectProgressBar({
  status,
  value,
  className,
  "aria-label": ariaLabel,
}: ProjectProgressBarProps) {
  const pct = Math.min(100, Math.max(0, value));
  const fill = projectStatusProgressFillClass(status);
  return (
    <div
      className={cn("h-2 w-full overflow-hidden rounded-full bg-muted", className)}
      role="progressbar"
      aria-valuenow={pct}
      aria-valuemin={0}
      aria-valuemax={100}
      aria-label={ariaLabel ?? `ຄວາມຄືບໜ້າ ${pct}%`}
    >
      <div
        className={cn(
          "h-full rounded-full transition-[width] duration-200",
          fill,
        )}
        style={{ width: `${pct}%` }}
      />
    </div>
  );
}
